import * as React from 'react';
import { Store } from 'redux';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
// eslint-disable-next-line import/no-unassigned-import
import 'isomorphic-fetch';

import '../style/global-styles.css';

import { LoginPage } from './components/login-page/login-page';
import { ILoginStore, createLoginStore } from './redux/configure-store';

export class App extends React.Component<object, object> {
  private store: Store<ILoginStore>;

  constructor(props: object) {
    super(props);
    this.store = createLoginStore();
  }

  render() {
    return (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      <Provider store={this.store as any}>
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore */}
        <Router>
          <Switch>
            <Route path="/l" component={LoginPage} />
          </Switch>
        </Router>
      </Provider>
    );
  }
}
render(<App />, document.getElementById('reactroot'));
